<template>
    <div class="hts-distributing__detail-map">
        <hts-map-vehicle
            ref="map"
            :route="route"
            :show-location="showLocation"
            center-marker />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  journey: Object,
  loading: Boolean
})

const { map: mapStore } = $store()

const { loading, journey }: any = toRefs(props)
const route = ref<any>(null)
const map = ref()
const latLngLocationRoutes = ref([] as google.maps.LatLngLiteral[])

const showLocation = computed(() => {
  return mapStore.getShowLocation
})

watch(
  () => showLocation.value,
  (val) => {
    if (!val) {
      map.value && map.value.removeAdvanceMarkers()

      if (route.value) {
        map.value && map.value.renderNodeListInRoute(latLngLocationRoutes.value)
      }
      return
    }

    map.value && map.value.renderNodeList()
  }
)

watch(
  () => journey.value,
  (val: any) => {
    renderJourneyRoute(val)
  },
  { deep: true }
)
const renderJourneyRoute = (journey: any) => {
  if (!journey || !journey.stages) {
    return
  }
  const { stages } = journey
  if (!Array.isArray(stages) || stages.length < 2) {
    return
  }
  let originData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let destinationData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let originLocationName = 'A'
  let destinationLocationName = 'B'
  latLngLocationRoutes.value = []
  const waypointsData: { location: google.maps.LatLngLiteral; node?: string; locationName?: string }[] = []

  stages.forEach((s: any, i: number) => {
    if (isNaN(s.lat) || isNaN(s.lng)) {
      return
    }
    const lat = parseFloat(s.lat?.toString())
    const lng = parseFloat(s.lng?.toString())
    latLngLocationRoutes.value.push({ lat, lng, nodeLocationName: s.nodeLocationName } as google.maps.LatLngLiteral)

    if (i === 0) {
      originData = { lat, lng } as google.maps.LatLngLiteral
      originLocationName = s.nodeLocationName
      return
    }
    if (i === stages.length - 1) {
      destinationData = { lat, lng } as google.maps.LatLngLiteral
      destinationLocationName = s.nodeLocationName
      return
    }

    waypointsData.push({
      location: { lat, lng } as google.maps.LatLngLiteral,
      node: s.node,
      locationName: s.nodeLocationName
    })
  })

  route.value = {
    originData,
    destinationData,
    waypointsData,
    options: {
      originLocationName,
      destinationLocationName,
      sameOriginDestination: originData.lat === destinationData.lat && originData.lng === destinationData.lng
    }
  }
  renderLocationRoute()
}

const renderLocationRoute = () => {
  nextTick(() => {
    if (showLocation.value) {
      return
    }

    if (!latLngLocationRoutes.value || !latLngLocationRoutes.value.length) {
      map.value && map.value.removeAdvanceMarkers()
      return
    }

    map.value && map.value.removeAdvanceMarkers()
    map.value && map.value.renderNodeListInRoute(latLngLocationRoutes.value)
  })
}

onMounted(() => {
  if (journey.value) {
    renderJourneyRoute(journey.value)
  }
})
</script>
